module.exports = __webpack_public_path__ + "img/3-5.b2941182.svg";